import React from 'react'
import { Container } from '@mui/material'
import { ArrowForward, PostAdd } from '@mui/icons-material'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import Header from '../Components/Header'
import Footer from '../Components/Footer'
import TopHeader from '../Components/TopHeader'
import TitrePage from './TitrePage'
import Reveal from '../Components/ui/Reveal'
import ImageSlot from '../Components/ui/ImageSlot'
import SectionHeader from '../Components/ui/SectionHeader'
import ValueGrid from '../Components/ui/ValueGrid'
import CtaBand from '../Components/ui/CtaBand'
import { Images } from '../Data/Images'

interface Props { }

function Carriere(props: Props) {
    const { t } = useTranslation();
    const navigate = useNavigate()

    const go = (link: string) => {
        navigate(link)
        window.scrollTo({ top: 0 })
    }

    const values = [1, 2, 3, 4, 5].map((i) => ({
        title: t(`Carriere.Valeurs.valeur${i}.titre`),
        text: t(`Carriere.Valeurs.valeur${i}.contenu`),
    }))

    const reasons = [7, 9, 11, 13, 15].map((i) => ({
        title: t(`Carriere.texte${i}`),
        text: t(`Carriere.texte${i + 1}`),
    }))

    const apply = (
        <button className="ibg-btn ibg-btn--light" onClick={() => go('/contact')}>
            <PostAdd fontSize="small" /> {t("Carriere.texte19")}
        </button>
    )

    return (
        <div className="ibg-page">
            <TopHeader />
            <Header />
            <TitrePage image={Images.pageHeroes.career.src} titre={'titrePage.carriere.titre'} eyebrow={'carriere'} lien='carriere' pageDescription={'titrePage.carriere.description'} keyWords={'titrePage.carriere.keywords'} actions={apply} />

            <section className="ibg-section">
                <Container maxWidth="lg">
                    <div className="ibg-split ibg-split--center">
                        <div className="ibg-split__text">
                            <SectionHeader eyebrow={t("Carriere.texte1")} title={t("Carriere.texte2")} />
                            <Reveal delay={0.1}>
                                <p className="ibg-body">{t("Carriere.texte3")}</p>
                                <button className="ibg-link" onClick={() => go('/contact')}>
                                    {t("Carriere.texte4")} <ArrowForward fontSize="small" />
                                </button>
                            </Reveal>
                        </div>
                        <Reveal delay={0.15} className="ibg-split__media">
                            <ImageSlot image={Images.career} ratio="5 / 4" />
                        </Reveal>
                    </div>
                </Container>
            </section>

            <section className="ibg-section ibg-section--surface">
                <Container maxWidth="lg">
                    <SectionHeader eyebrow={t("nom")} title={t("Carriere.texte5")} />
                    <ValueGrid items={values} />
                </Container>
            </section>

            <section className="ibg-section">
                <Container maxWidth="lg">
                    <SectionHeader eyebrow={t("Pages.whyUs")} title={t("Carriere.texte6")} />
                    <ol className="ibg-list">
                        {reasons.map((r, index) => (
                            <Reveal key={r.title} delay={index * 0.05}>
                                <li className="ibg-list__item">
                                    <span className="ibg-list__index">{String(index + 1).padStart(2, '0')}</span>
                                    <h3 className="ibg-h4">{r.title}</h3>
                                    <p className="ibg-small">{r.text}</p>
                                </li>
                            </Reveal>
                        ))}
                    </ol>
                </Container>
            </section>

            <CtaBand title={t("Carriere.texte17")} text={t("Carriere.texte18")}>
                {apply}
                <button className="ibg-btn ibg-btn--outline-light" onClick={() => go('/about')}>
                    {t("apropos")}
                </button>
            </CtaBand>

            <Footer />
        </div>
    )
}

export default Carriere
